module.exports = __webpack_public_path__ + "static/media/RVTN05.44156725.jpg";